import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55b0ed9d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0ed9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/api/stage/imc_api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b0ed9d')) {
      api.createRecord('55b0ed9d', component.options)
    } else {
      api.reload('55b0ed9d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=55b0ed9d&scoped=true", function () {
      api.rerender('55b0ed9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/buttons/index.vue"
export default component.exports